var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hidden
    ? _c(
        "v-navigation-drawer",
        {
          staticClass: "slideLeft_container",
          attrs: {
            elevation: "0",
            width: "240",
            clipped: _vm.$vuetify.breakpoint.lgAndUp,
            app: "",
          },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-item-group",
                {
                  attrs: {
                    color: "primary",
                    "active-class": "mrc_item_active primary--text",
                  },
                  model: {
                    value: _vm.list,
                    callback: function ($$v) {
                      _vm.list = $$v
                    },
                    expression: "list",
                  },
                },
                [
                  _vm._l(_vm.naviData, function (item) {
                    return !_vm.isDemo
                      ? [
                          _c(
                            "div",
                            { key: "div" + item.uuid },
                            [
                              !item.menus_tree
                                ? _c("v-list-item", {
                                    key: "pri" + item.uuid,
                                    staticClass:
                                      "text-caption mrc_listitem_container",
                                    class:
                                      _vm.curNavKey == item.uuid
                                        ? "mrc_item_active primary--text v-list-item--active"
                                        : "",
                                    attrs: {
                                      "input-value": _vm.curNavKey == item.uuid,
                                      value: item.uuid,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toRouter(item.url, item.uuid)
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var active = ref.active
                                            var toggle = ref.toggle
                                            return [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "line-clamp3",
                                                      class:
                                                        active ||
                                                        _vm.curNavKey ==
                                                          item.uuid
                                                          ? "text-subtitle-2"
                                                          : "text-body-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$getCommonLangValue(
                                                              item.menu_name
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.curNavKey == item.uuid
                                                    ? _c(
                                                        "v-list-item-action",
                                                        {
                                                          staticClass:
                                                            "dot_active",
                                                        },
                                                        [
                                                          _c("v-sheet", {
                                                            staticClass:
                                                              "dot pa-0",
                                                            attrs: {
                                                              color: "primary",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _c(
                                    "v-list-group",
                                    {
                                      key: item.uuid,
                                      attrs: {
                                        "no-action": "",
                                        value:
                                          item.open === undefined
                                            ? _vm.isMenuActive(item.uuid)
                                            : item.open,
                                        "append-icon": "keyboard_arrow_down",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          item.menu_icon
                                            ? {
                                                key: "prependIcon",
                                                fn: function () {
                                                  return undefined
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                          {
                                            key: "activator",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "v-list-item-content",
                                                  {
                                                    staticClass:
                                                      "mrc_listitem_container",
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "line-clamp3 text-body-2",
                                                        class: item.open
                                                          ? "primary--text"
                                                          : "",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                item.menu_name
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._l(item.menus_tree, function (it) {
                                        return [
                                          it.menus_tree
                                            ? _c(
                                                "v-list-group",
                                                {
                                                  key: it.uuid,
                                                  attrs: {
                                                    "sub-group": "",
                                                    "no-action": "",
                                                    value:
                                                      it.open === undefined
                                                        ? _vm.isMenuActive(
                                                            it.uuid
                                                          )
                                                        : it.open,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "v-list-item-content",
                                                              {
                                                                staticClass:
                                                                  "pl-0 ml-0 mrc_listitem_container",
                                                                attrs: {
                                                                  value:
                                                                    it.uuid,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "line-clamp3 text-body-2",
                                                                    class:
                                                                      it.open
                                                                        ? "primary--text"
                                                                        : "",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            it.menu_name
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                _vm._l(
                                                  it.menus_tree,
                                                  function (i) {
                                                    return _c("v-list-item", {
                                                      key: i.uuid,
                                                      staticClass:
                                                        "mrc_listitem_container",
                                                      class:
                                                        _vm.curNavKey == i.uuid
                                                          ? "mrc_item_active primary--text v-list-item--active"
                                                          : "",
                                                      attrs: {
                                                        "input-value":
                                                          _vm.curNavKey ==
                                                          i.uuid,
                                                        value: i.uuid,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toRouter(
                                                            i.url,
                                                            i.uuid
                                                          )
                                                        },
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var active =
                                                                ref.active
                                                              var toggle =
                                                                ref.toggle
                                                              return [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "line-clamp3",
                                                                        class:
                                                                          active ||
                                                                          _vm.curNavKey ==
                                                                            i.uuid
                                                                            ? "text-subtitle-2"
                                                                            : "text-body-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                i.menu_name
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    active ||
                                                                    _vm.curNavKey ==
                                                                      i.uuid
                                                                      ? _c(
                                                                          "v-list-item-action",
                                                                          {
                                                                            staticClass:
                                                                              "dot_active",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-sheet",
                                                                              {
                                                                                staticClass:
                                                                                  "pa-0 dot",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "primary",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : _c("v-list-item", {
                                                key: it.uuid,
                                                staticClass:
                                                  "mrc_listitem_container",
                                                class:
                                                  _vm.curNavKey == it.uuid
                                                    ? "mrc_item_active primary--text v-list-item--active"
                                                    : "",
                                                attrs: {
                                                  value: it.uuid,
                                                  "input-value":
                                                    _vm.curNavKey == it.uuid,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toRouter(
                                                      it.url,
                                                      it.uuid
                                                    )
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var active = ref.active
                                                        var toggle = ref.toggle
                                                        return [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "line-clamp3",
                                                              class:
                                                                active ||
                                                                _vm.curNavKey ==
                                                                  it.uuid
                                                                  ? "text-subtitle-2"
                                                                  : "text-body-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$getCommonLangValue(
                                                                      it.menu_name
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          active ||
                                                          _vm.curNavKey ==
                                                            it.uuid
                                                            ? _c(
                                                                "v-list-item-action",
                                                                {
                                                                  staticClass:
                                                                    "dot_active",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-sheet",
                                                                    {
                                                                      staticClass:
                                                                        "dot pa-0",
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                        ]
                                      }),
                                    ],
                                    2
                                  ),
                              _c("v-divider"),
                            ],
                            1
                          ),
                        ]
                      : _vm._e()
                  }),
                  _vm._l(_vm.naviData, function (item) {
                    return _vm.isDemo
                      ? [
                          _c(
                            "div",
                            { key: "div" + item.id },
                            [
                              !item.children
                                ? _c("v-list-item", {
                                    key: "pri" + item.id,
                                    staticClass:
                                      "text-caption mrc_listitem_container",
                                    attrs: { value: item.id },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toRouter(item.path)
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var active = ref.active
                                            var toggle = ref.toggle
                                            return [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "line-clamp3",
                                                      class: active
                                                        ? "text-subtitle-2"
                                                        : "text-body-2",
                                                    },
                                                    [_vm._v(_vm._s(item.title))]
                                                  ),
                                                  active
                                                    ? _c(
                                                        "v-list-item-action",
                                                        {
                                                          staticClass:
                                                            "dot_active",
                                                        },
                                                        [
                                                          _c("v-sheet", {
                                                            staticClass:
                                                              "dot pa-0",
                                                            attrs: {
                                                              color: "primary",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _c(
                                    "v-list-group",
                                    {
                                      key: item.id,
                                      attrs: {
                                        value: false,
                                        "no-action": "",
                                        "append-icon": "keyboard_arrow_down",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          item.meta.isSvg
                                            ? {
                                                key: "prependIcon",
                                                fn: function () {
                                                  return [
                                                    item.meta.isSvg
                                                      ? _c("svg-icon", {
                                                          attrs: {
                                                            size: "24",
                                                            fill: "currentColor",
                                                            iconClass:
                                                              item.meta.icon,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : item.meta.icon
                                            ? {
                                                key: "prependIcon",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-icons-round text--secondary text--lighten-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.meta.icon)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                          {
                                            key: "activator",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "v-list-item-content",
                                                  {
                                                    staticClass:
                                                      "mrc_listitem_container",
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "line-clamp3 text-body-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.title)
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._l(item.children, function (it) {
                                        return [
                                          it.children
                                            ? _c(
                                                "v-list-group",
                                                {
                                                  key: it.id,
                                                  attrs: {
                                                    "sub-group": "",
                                                    "no-action": "",
                                                    value: false,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "v-list-item-content",
                                                              {
                                                                staticClass:
                                                                  "pl-0 ml-0 mrc_listitem_container",
                                                                attrs: {
                                                                  value: it.id,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "line-clamp3 text-body-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        it.title
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                _vm._l(
                                                  it.children,
                                                  function (i) {
                                                    return _c("v-list-item", {
                                                      key: i.id,
                                                      staticClass:
                                                        "mrc_listitem_container",
                                                      attrs: { value: i.id },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toRouter(
                                                            i.path
                                                          )
                                                        },
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var active =
                                                                ref.active
                                                              var toggle =
                                                                ref.toggle
                                                              return [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "line-clamp3",
                                                                        class:
                                                                          active
                                                                            ? "text-subtitle-2"
                                                                            : "text-body-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            i.title
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    active
                                                                      ? _c(
                                                                          "v-list-item-action",
                                                                          {
                                                                            staticClass:
                                                                              "dot_active",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-sheet",
                                                                              {
                                                                                staticClass:
                                                                                  "pa-0 dot",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "primary",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : _c("v-list-item", {
                                                key: it.id,
                                                staticClass:
                                                  "mrc_listitem_container",
                                                attrs: { value: it.id },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toRouter(it.path)
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var active = ref.active
                                                        var toggle = ref.toggle
                                                        return [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "line-clamp3",
                                                              class: active
                                                                ? "text-subtitle-2"
                                                                : "text-body-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(it.title)
                                                              ),
                                                            ]
                                                          ),
                                                          active
                                                            ? _c(
                                                                "v-list-item-action",
                                                                {
                                                                  staticClass:
                                                                    "dot_active",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-sheet",
                                                                    {
                                                                      staticClass:
                                                                        "dot pa-0",
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                        ]
                                      }),
                                    ],
                                    2
                                  ),
                              _c("v-divider"),
                            ],
                            1
                          ),
                        ]
                      : _vm._e()
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }